import NotificationPreferences from "@/domain/entities/user/NotificationPreferences";
import { NotificationSettings as NotificationSettingsMailvista } from "@cs_teamwaydev/mailvista-sdk_react";

const notificationPreferencesToDomainMapper = (
    notificationPreferences: NotificationSettingsMailvista,
): NotificationPreferences =>
    new NotificationPreferences({
        activatePushNotifications:
            notificationPreferences.activatePushNotifications,
        getUnreadDailyNotification:
            notificationPreferences.getUnreadDailyNotification,
        getUrgentMessageNotification:
            notificationPreferences.getUrgentMessageNotification,
        getDailySummaryNotification:
            notificationPreferences.getDailySummaryNotification,
    });

const notificationPreferencesToSDKMapper = (
    notificationPreferences: NotificationPreferences,
): NotificationSettingsMailvista => ({
    activatePushNotifications:
        notificationPreferences.activatePushNotifications,
    getUnreadDailyNotification:
        notificationPreferences.getUnreadDailyNotification,
    getUrgentMessageNotification:
        notificationPreferences.getUrgentMessageNotification,
    getDailySummaryNotification:
        notificationPreferences.getDailySummaryNotification,
});

export {
    notificationPreferencesToDomainMapper,
    notificationPreferencesToSDKMapper,
};
